import { EmbeddedWalletVersionEnum } from '@dynamic-labs/sdk-api-core';

import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';

/**
 * Checks if Dynamic WaaS (Wallet as a Service) is enabled for the current project.
 *
 * This function examines the project settings to determine if Dynamic WaaS is
 * enabled in the Dynamic Dashboard or not.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if Dynamic WaaS is enabled, false otherwise.
 */
export const isDynamicWaasEnabled = (client = getDefaultClient()) => {
  const projectSettings = client.projectSettings;

  assertDefined(projectSettings, 'Project settings are not available');

  const embeddedWalletSettings = projectSettings.sdk.embeddedWallets;

  const dynamicWaasIsEnabled =
    embeddedWalletSettings?.defaultWalletVersion ===
    EmbeddedWalletVersionEnum.V3;

  return dynamicWaasIsEnabled;
};
